import { LNotification } from '@lib/abpUtility'
import { notifySuccess } from '@lib/helper'
import { ReportModel } from '@models/report/reportModel'
import http from '@services/httpService'

class pbiSettingService {
  public async update(body: any) {
    let res = await http.put(
      'api/services/app/HostSettings/UpdatePowerBISettings',
      body
    )
    notifySuccess(
      LNotification('SUCCESS'),
      LNotification('SAVING_SUCCESSFULLY')
    )
    return res.data.result
  }
  public async get(): Promise<any> {
    let res = await http.get(
      'api/services/app/HostSettings/GetPowerBISettings',
      {}
    )

    return ReportModel.assign(res.data.result)
  }
}

export default new pbiSettingService()
